const STAT_CARD_CONFIG = [
  { key: 'profilesTotal', label: 'dashboard.profilesTotal', toneClass: 'text-bg-primary', iconClass: 'ti ti-users', to: '/profiles' },
  {
    key: 'profilesVerificationTotal',
    label: 'dashboard.onVerification',
    toneClass: 'text-bg-warning',
    iconClass: 'ti ti-user-search',
    to: '/profiles?status=verification',
  },
  {
    key: 'accountsLiveTotal',
    label: 'dashboard.liveAccounts',
    toneClass: 'text-bg-success',
    iconClass: 'ti ti-chart-line',
    to: '/accounts?type=live',
  },
  {
    key: 'accountsDemoTotal',
    label: 'dashboard.demoAccounts',
    toneClass: 'text-bg-info',
    iconClass: 'ti ti-flask',
    to: '/accounts?type=demo',
  },
  { key: 'documentsTotal', label: 'dashboard.documentsTotal', toneClass: 'text-bg-secondary', iconClass: 'ti ti-file-text', to: '/documents' },
  {
    key: 'documentsNewTotal',
    label: 'dashboard.newDocuments',
    toneClass: 'text-bg-danger',
    iconClass: 'ti ti-file-plus',
    to: '/documents?status=new',
  },
  {
    key: 'processedDepositsTotal',
    label: 'dashboard.processedDeposits',
    toneClass: 'text-bg-success',
    iconClass: 'ti ti-arrow-down-left-circle',
    to: '/transactions?type=deposit&status=processed',
  },
  {
    key: 'processedWithdrawalsTotal',
    label: 'dashboard.processedWithdrawals',
    toneClass: 'text-bg-primary',
    iconClass: 'ti ti-arrow-up-right-circle',
    to: '/transactions?type=withdrawal&status=processed',
  },
];

function formatNumber(value) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return '0';
  }

  return new Intl.NumberFormat('en-US').format(numeric);
}

export function buildProfileStatsCardsModel(dto) {
  return STAT_CARD_CONFIG.map((config) => ({
    key: config.key,
    label: config.label,
    value: formatNumber(dto?.[config.key] ?? 0),
    toneClass: config.toneClass,
    iconClass: config.iconClass,
    to: config.to,
  }));
}
